// src/http.js
import axios from 'axios';

let authState = localStorage.getItem('authState');
if (authState) {
    authState = JSON.parse(authState);
} else {

}

let guestToken = localStorage.getItem('guestToken');
// 临时身份信息
if (guestToken === null || guestToken === '') {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    const length = 16;
    const _guest_token = Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
    localStorage.setItem('guestToken', _guest_token);
}

// 不校验登录接口
const whitelistUrl = [
    '/api/send/code',
    '/api/auth/login',
    '/api/claim-prize/commit',
    '/api/claim-prize/history',
    '/api/claim-prize/detail',
];

const http = axios.create({
    baseURL: process.env.VUE_APP_API_URL, // 你的API端点
    headers: {
        'Content-Type': 'application/json',
        // 其他通用头部信息
        'Authorization': authState != null ? authState.token : '',
        'Guest-Token': guestToken != null ? guestToken : '',
    },
    // 其他通用配置
});

// 添加请求拦截器
http.interceptors.request.use(
    function (config) {
        // 在发送请求之前做些什么
        // 例如，你可以在这里检查 token、请求参数等
        // 如果需要取消请求，可以返回 Promise.reject(new Error('取消请求'));

        // 假设我们在这里检查是否有一个名为 'token' 的请求头
        console.log('====request before', config, config.headers.Authorization, config.url, whitelistUrl.includes(config.url));

        if (!whitelistUrl.includes(config.url) && !config.headers.Authorization) {
            // 如果没有 token，则抛出一个错误并阻止请求
            // return Promise.reject(new Error('没有提供有效的 token'));
            // message.error('Please verify your email first');
            console.log('======没有token ， 校验没通过');
            // return Promise.reject(new axios.Cancel('请求被阻断'));
            // return Promise.resolve({ blocked: true });
            return Promise.resolve({ blocked: true, message: '请求被手动阻断' });
            // return Promise.reject(new Error('没有提供有效的 token'));
        }

        // 否则，继续发送请求
        return config;
    },
    function (error) {
        // 对请求错误做些什么
        console.log('================before request error');
        return Promise.reject(error);
    }
);

// 添加响应拦截器
http.interceptors.response.use(
    function (response) {
        // 对响应数据做点什么
        // 假设你希望所有请求都返回 data 字段的内容
        // 并且如果返回了特定的错误码，你想抛出一个错误
        const { data, status } = response;

        console.log('======= interceptors response onFulfilled');

        if (data.code === 401) {
            // 未授权状态
            console.log('===Not logged in====');
            localStorage.removeItem('authState');
        }

        // 这里的处理逻辑取决于你的后端API如何设计
        // 例如，如果后端在发生错误时返回了一个带有错误信息的 data 对象
        if (status !== 200) {
            // 如果不是200，可能需要根据具体业务逻辑处理错误
            return Promise.reject(new Error(data.message || 'Error'));
        } else {
            return response;
        }

        // 假设返回的数据结构是 { code: 200, message: 'Success', data: {...} }
        // 并且你想返回 data 字段而不是整个响应对象
        /*if (data.code === 200) {
            return data.data; // 只返回 data 字段
        }*/

        // 如果返回了其他错误码，你可能想要抛出一个具体的错误
        //return Promise.reject(new Error(data.message || 'Unknown Error'));
    },
    function (error) {
        console.log('======= interceptors response onRejected');

        // 对响应错误做点什么
        // 这里你可以统一处理请求错误，比如网络错误、超时等
        // 也可以在这里进行错误信息的格式化或转换

        // 例如，你可以根据需求返回特定的错误对象或信息
        //return Promise.reject(error);
    }
);

export default http;
